import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-response-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './response-modal.component.html',
  styleUrl: './response-modal.component.css'
})
export class ResponseModalComponent {
  message: string = '';
  @Input() showCancel: boolean = false;
  @Input() status: boolean = false;
  @Input() sopname: string = '';
  @Input() datetime: string = '';
  @Input() description: string = '';
  sopInfo: any;
  constructor(public activeModal: NgbActiveModal) { }
}
